import React from 'react'
import Pill from '../_pill'

const PillDefault = (props) => {
  return (
    <div>
      <Pill
          text="default"
          {...props}
      />
    </div>
  )
}

export default PillDefault
